import type {AuthComponentProps} from '@cohort/wallet/apps/AuthComponent';
import {useTranslation} from 'react-i18next';

export const CustomAuthComponent: React.FC<AuthComponentProps> = ({appSpec}) => {
  const {t} = useTranslation('apps', {
    keyPrefix: 'customAuthComponent',
  });

  return <div>{t('noAppFound', {id: appSpec.id})}</div>;
};
